import React, { FunctionComponent } from 'react';

import { withTrack, WithTrack } from '../../utils/analytics';
import { useTranslation } from 'react-i18next';
import { useShareContext } from '../../context/ShareContext';

export type SMSShareProps = WithTrack & {
  className?: string;
  trackingData?: Record<string, any>;
  onClick?: () => void;
};

export const SMSShare: FunctionComponent<SMSShareProps> = ({
  className,
  track,
  trackingData,
  onClick,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { shareItems } = useShareContext();

  const trackClick = () => {
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'sms',
      ...trackingData,
    });
    if (onClick) {
      onClick();
    }
  };

  return (
    <a
      href={`sms://?&body=${shareItems.sms.message}`}
      className={`jg-btn jg-btn--sms ${className}`}
      onClick={trackClick}
    >
      <span className="jg-sr-only">{t('common.shareBy')}</span>
      {t('common.sms')}
    </a>
  );
};

export default withTrack(SMSShare);
